export default __webpack_public_path__ + "static/media/img (1).a421a244.jpg";